const criteriaBySubmitted = (a, b) => {
  return b.submitted - a.submitted
}

const criteriaByLQs = (a, b) => {
  return b.submitted_hl - a.submitted_hl
}

const criteriaByLQEs = (a, b) => {
  return b.qualified - a.qualified
}

const criteriaByScreenings = (a, b) => {
  return b.screenings - a.screenings
}

const criteriaByAverageSubmittedsPerScreening = (a, b) => {
  return getNumber(b.submitted / b.screenings) - getNumber(a.submitted / a.screenings)
}

const criteriaByAverageLQsPerScreening = (a, b) => {
  return getNumber(b.submitted_hl / b.screenings) - getNumber(a.submitted_hl / a.screenings)
}

const criteriaByAverageLQEsPerScreening = (a, b) => {
  return getNumber(b.qualified / b.screenings) - getNumber(a.qualified / a.screenings)
}



export {
  criteriaBySubmitted,
  criteriaByLQs,
  criteriaByLQEs,
  criteriaByScreenings,
  criteriaByAverageSubmittedsPerScreening,
  criteriaByAverageLQsPerScreening,
  criteriaByAverageLQEsPerScreening,
}

function getNumber (value) {
  if (isNaN(value)) {
    return 0
  }
  return value
}
